<router-outlet>

    
    
</router-outlet>